import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import "./EulaPages.css"; // Reuse the same CSS file

const EULA = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/eula.md") // Ensure this file exists
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="legal-container">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default EULA;
